// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@bg/Overrides/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationHeader";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import xScreen from "@bg/XDL/Utilities/xScreen";
import { css } from "styled-components";

headerStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px 60px;
        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr;
        }
    `,
};

headerStyles.titleGridItem = {
    css: css`
        width: 100%;
        grid-column: 1/3;
        ${xScreen("lte", "md")} {
            grid-column: initial;
        }
    `,
};

headerStyles.titleText = {
    variant: "h3",
    css: css`
        margin-bottom: 0;
    `,
};

headerStyles.orderLabel = {
    lineHeight: fontConfig.lineHeight.regular,
    weight: fontConfig.weight.bold,
};

headerStyles.orderValue = {
    lineHeight: fontConfig.lineHeight.regular,
    weight: fontConfig.weight.regular,
    css: css`
        margin-left: 4px;
    `,
};

headerStyles.orderInfoGridItem = {};
